import { render, staticRenderFns } from "./CardOrderPenunjangIgd.vue?vue&type=template&id=15c3047e&scoped=true&"
import script from "./CardOrderPenunjangIgd.vue?vue&type=script&lang=ts&"
export * from "./CardOrderPenunjangIgd.vue?vue&type=script&lang=ts&"
import style0 from "./CardOrderPenunjangIgd.vue?vue&type=style&index=0&id=15c3047e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3047e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VContainer,VIcon,VTab,VTabItem,VTabs})
